import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { CmsConfig, provideDefaultConfig, UrlModule } from '@spartacus/core'
import { SpinnerModule } from '@spartacus/storefront'
import { UserPermissionsGuard } from '../../../../guards/user-permissions.guard'
import { SharedModule } from '../../../shared/shared.module'
import { CreditClaimAttachmentsModalModule } from '../credit-claim-attachments-modal/credit-claim-attachments-modal.module'
import { NewCreditClaimModalModule } from '../new-credit-claim-modal/new-credit-claim-modal.module'
import { CreditClaimsDetailsComponent } from './credit-claims-details.component'

@NgModule({
  declarations: [CreditClaimsDetailsComponent],
  imports: [
    CommonModule,
    RouterModule,
    UrlModule,
    SharedModule,
    SpinnerModule,
    NewCreditClaimModalModule,
    CreditClaimAttachmentsModalModule
  ],
  providers: [
    provideDefaultConfig({
      cmsComponents: {
        CreditClaimDetailsComponent: {
          component: CreditClaimsDetailsComponent,
          guards: [UserPermissionsGuard]
        }
      }
    } as CmsConfig)
  ]
})
export class CreditClaimsDetailsModule {}
